import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M90.308 44.564l-7.837.913-.398-3.097 11.606-1.352a1.574 1.574 0 0 1 1.712 1.198l2.698 11.37-3.046.684-1.836-7.733c-10.403 18.294-33.474 25.136-52.09 15.238l1.643-3.09c17.02 9.05 38.144 2.714 47.548-14.131z"
      />
      <path fill="#53A2D9" d="M39 79h8.844v26H39zM51 73h8.844v32H51z" />
      <path fill="#7BB835" d="M64 81h8.844v24H64zM77 73h8.844v32H77z" />
      <path fill="#15539F" d="M89 60h8.844v45H89zM102 47h8.844v58H102z" />
      <path stroke="#51565C" strokeWidth="3.5" d="M35 45.566V109h80" />
    </g>
  </Svg>
)
